<template>
  <div class="bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end p-3">
      <div class="d-flex flex-column">
        <h5>Sample Input</h5>
        <p class="text-gray-500">Basic input. Enable the <span class="text-danger">inline </span> prop to allow inline editing.</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : view === 'preview'}" @click="view = 'preview'">Preview</b-button>
        <b-button :class="{'active' : view === 'code'}"  @click="view = 'code'">Code</b-button>
      </ButtonGroup>
    </div>

    <CodePreviewViewer :viewMode="view" :codeSample="require('@/components/local/Input/input.js').default">
      <template v-slot:preview>
        <div class="bg-white w-100 p-3">
          <Input v-model="text" label="Default">
            <template v-slot:label="data">
              <span>{{ data.item }}</span>
            </template>
          </Input>
          <p class="mt-2">Value: <strong v-if="text">"{{ text }}"</strong></p>

          <br><br>

          <Input v-model="textInline" label="Inline" inline>
            <template v-slot:label="data">
              <span>{{ data.item }}</span>
            </template>
          </Input>
          <p class="mt-2">Value: <strong v-if="textInline">"{{ textInline }}"</strong></p>
        </div>
      </template>
    </CodePreviewViewer>
  </div>
</template>

 

<script>
import Input from '@/components/export/Input/Input'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'

export default {
 components: { Input, ButtonGroup, CodePreviewViewer },
 data () {
   return {
     view: 'preview',
     viewSizing: 'preview',
     text:'',
     textInline:'The quick brown fox jumps over the lazy dog',
     errors: 'Sample error message here'
   }
 }
}
</script>

